export default {
    getStarted: 'Démarrer',
    next: 'Suivant',
    previous: 'Précédent',
    step: 'Étape',
    icons: {
        copyright: 'mdi-account-circle-outline',
    }
};
